import { FormContainer } from "@/components/form/FormContainer";
import { useResourceOne, useResourceUpdate } from "@/hooks";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useResourceContext } from "@/layouts/ResourceContext";
import { UpdateWrapper } from "@/layouts/UpdateWrapper";
import { RESOURCE_TYPE_TENANTS } from "@/resources-def";
import { Button, Input, Space, Spin } from "antd";
import { useRef, useState } from "react";

const RESOURCE = RESOURCE_TYPE_TENANTS;

export const EditTenantPage = () => {
  const formRef = useRef();
  const navigate = useResourceNavigate();
  const { state } = useResourceContext();
  const [selectedTenant] = state.selectedResources;
  const { mutateAsync, isLoading: isSaving } = useResourceUpdate();
  const { data, isLoading, isError } = useResourceOne({
    resource: RESOURCE,
    id: selectedTenant?.name,
  });

  // const toBool = (val) => {
  //   return val == true || val == "true" || val == "True";
  // }
  // if(data) {
  //   data.properties.email_mfa = toBool(data.properties.email_mfa);
  //   data.properties.sms_mfa = toBool(data.properties.sms_mfa);
  //   data.properties.app_mfa = toBool(data.properties.app_mfa);
  // }
  if(data)
    data.name = selectedTenant?.name;

  const mfaEnum = {
      "ON": {text: 'Required MFA - Recommended'}, 
      // "OPTIONAL": {text: 'Optional MFA', value: 'OPTIONAL'},
      "OFF": {text: 'No MFA', value: 'OFF'}
  };
  const rawSchema = [
    {
      i18nTitle: 'config.tenants.form.name',
      title: "Tenant Name",
      dataIndex: "name",
      width: "md",
      fieldProps: {
        disabled: "true"
      }
    },
    {
      i18nTitle: "config.tenants.form.emailMFAEnabled",
      title: "MFA Enforcement",
      dataIndex: "mfa_config",
      valueEnum: mfaEnum,
      valueType: "select",
      initialValue: true,
    },
    {
      i18nTitle: "config.tenants.form.emailMFAEnabled",
      title: "Email message as MFA method",
      dataIndex: "email_mfa",
      valueType: "switch",
      initialValue: true,
      dependencies: ['mfa_config'],
      shouldUpdate: ((prevValues, currentValues) => prevValues.mfa_config !== currentValues.mfa_config),
      renderFormItem:((item,_, form ) => {
        if ("OFF" === form.getFieldValue("mfa_config")) {
          return null; // 如果 showField 为 false，则不渲染该字段
        }
        return _.defaultRender(item);
      })
    },
    {
      i18nTitle: "config.tenants.form.appMFAEnabled",
      title: "Authenticator App as MFA method",
      dataIndex: "app_mfa",
      valueType: "switch",
      initialValue: true,
      dependencies: ['mfa_config'],
      shouldUpdate: ((prevValues, currentValues) => prevValues.mfa_config !== currentValues.mfa_config),
      renderFormItem:((item,_, form ) => {
        if ("OFF" === form.getFieldValue("mfa_config")) {
          return null; // 如果 showField 为 false，则不渲染该字段
        }
        return _.defaultRender(item);
      })
    }
  ];

  const doUpdateTenant = async (values) => {
    try {
      const resp = await mutateAsync({ values });
      console.log(resp);
    } catch (error) {
      // formRef.current.setFields([
      //   {
      //     name: "name",
      //     errors: [error.message],
      //   },
      // ]);
    }
  };

  const onFormValuesChange = (changedValues, allValues) => {
    console.log(changedValues, allValues);
  };

  return (
    <UpdateWrapper
      i18nTitle="tenants.edit.title"
      desc={[
      ]}
      footer={
        <Space>
          <Button onClick={() => {
            navigate({ resource: RESOURCE_TYPE_TENANTS, action: "list" });
          }}>Cancel</Button>
          <Button type="primary" onClick={() => formRef.current.submit()}>Save</Button>
        </Space>
      }
    >
      {isLoading && <div><Spin/></div>}
      { !isLoading && <FormContainer
        formRef={formRef}
        initValue={data}
        schema={rawSchema}
        onFinishCallback={doUpdateTenant}
        onValuesChange={onFormValuesChange}
        style={{ paddingTop: 24 }}
      />}
    </UpdateWrapper>
  );
};